/* eslint-disable */

import { React, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { CssBaseline, ThemeProvider, typographyClasses } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import RTL from './layouts/full-layout/customizer/RTL';
import ThemeSettings from './layouts/full-layout/customizer/ThemeSettings';
import 'react-perfect-scrollbar/dist/css/styles.css';

import Register from './views/authentication/Register';
import Login from './views/authentication/Login';
import FullLayout from './layouts/full-layout/FullLayout';
import Dashboard1 from './views/dashboard/Dashboard';
import * as types from './redux/constants/index';
import Editor from './views/editor/Editor';
import Entry from './components/entry/Entry';
import Catalog from './views/catalog/Catalog';

import customTheme from './theme';
import { createTheme } from '@material-ui/system';
import { updateCapsuleCount } from './actions/capsuleActions';

const App = () => {
  // const routing = useRoutes(Router);
  const theme = ThemeSettings();
  const customizer = useSelector((state) => state.CustomizerReducer);
  const profile = useSelector(state => state.Authentication.profile);
  const dispatch = useDispatch();

  /* reads in user token from local storage only on app initialization.
     sets the debug configuration variables. */
  useEffect(() => {
    const profile = JSON.parse(localStorage.getItem('profile'));
    
    //set debugging output if in development
    if(process.env.NODE_ENV != "production"){
      localStorage.setItem("debug", "capsule,api,catalog,entry");
    }

    //read the profile info into state on app start
    if (profile) {
      dispatch({
        type: types.USER_LOGGED_IN,
        payload: profile
      })

      //update the capsule counter
      dispatch(updateCapsuleCount);
    }

  }, [])

  return (
    <ThemeProvider theme={theme}>
      <ThemeProvider theme={(theme) => createTheme({ ...theme, ...customTheme })}>
        <RTL direction={customizer.activeDir}>
          <CssBaseline />
          <Routes>
            <Route path="/" element={<Navigate to="/register" />} />
            <Route path="/test" element={<Entry />} />
            <Route path="/register" element={profile ? <Navigate to="/app" /> : <Register />} />
            <Route path="/login" element={profile ? <Navigate to="/app" /> : <Login />} />
            <Route path="/app" element={profile ? <FullLayout /> : <Navigate to="/login" />} >
              <Route index element={<Dashboard1 />} />
              <Route path="/editor" element={<Editor />} ></Route>
              <Route path="/catalog" element={<Catalog />} ></Route>
            </Route>
          </Routes>
        </RTL>
      </ThemeProvider>
    </ThemeProvider>
  );
};

export default App;
